import { PublicClientApplication } from "@azure/msal-browser";

// Use configured authority tenant segment if provided, otherwise default to "common" for multi-tenant

// Legacy tenant segment source:
// const authorityTenantSegment = process.env.REACT_APP_AZURE_APPLICATION_ID || "common";
const authorityTenantSegment = (
  process.env.REACT_APP_AZURE_TENANT_ID ||
  process.env.REACT_APP_AZURE_APPLICATION_ID ||
  "common"
).trim();

if (authorityTenantSegment === "common") {
  console.warn(
    "[MSAL Config] Falling back to /common authority. Set REACT_APP_AZURE_TENANT_ID for single-tenant applications.",
  );
}

// Determine redirect URI dynamically based on current environment
const getRedirectUri = () => {
  // For deployed environments, use the current origin
  // For localhost, use the environment variable or default to localhost:3000
  const origin = window.location.origin;
  return `${origin}`;
};

export const authConfig = {
  clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
  authority: `https://login.microsoftonline.com/${authorityTenantSegment}`,
  redirectUri: getRedirectUri(),
  navigateToLoginRequestUrl: true,
  applicationId: process.env.REACT_APP_AZURE_APPLICATION_ID,
};

const cache = {
  cacheLocation: "sessionStorage",
  storeAuthStateInCookie: true,
};
const getMsalConfig = () => {
  const msalConfig = {
    auth: authConfig,
    cache: cache,
  };

  return msalConfig;
};

const msalConfig = getMsalConfig();
export const msalInstance = new PublicClientApplication(msalConfig);
